import { combineReducers } from 'redux';
import motion from './motion';

const reducers = combineReducers({ motion });

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js